import { useEffect } from 'react';

import { useThemeStore } from '@/stores/theme-store';

import { applyThemeToDocument } from './theme';

export const useApplyTheme = () => {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    applyThemeToDocument(theme);
  }, [theme]);
};
